'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _checkFiltersQuantity = require('./checkFiltersQuantity');var _checkFiltersQuantity2 = _interopRequireDefault(_checkFiltersQuantity);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var calculateMobileActiveFiltersQuantity = function calculateMobileActiveFiltersQuantity(routeData) {var
  optionType =



  routeData.optionType,_routeData$params = routeData.params,rooms = _routeData$params.rooms,types = _routeData$params.types,status = _routeData$params.status,price = _routeData$params.price,bathrooms = _routeData$params.bathrooms,toilets = _routeData$params.toilets,area = _routeData$params.area,constructionYear = _routeData$params.constructionYear,locationSearch = routeData.locationSearch,locale = routeData.locale;

  var filters = {
    rooms: rooms || _constants.initialFieldsValuesForMobileFilters.rooms,
    propertyTypes: types || _constants.initialFieldsValuesForMobileFilters.propertyTypes,
    status: status || _constants.initialFieldsValuesForMobileFilters.status,
    minPrice: price.minPrice || '',
    maxPrice: price.maxPrice || '',
    price: price.minPrice || price.maxPrice,
    location: (0, _get2.default)(locationSearch, '[' + locale + '].formatted') || (0, _get2.default)(locationSearch, 'en.formatted'),
    toilets: toilets || ['all'],
    bathrooms: bathrooms || ['all'],
    area: area || {},
    constructionYear: constructionYear || {},
    optionType: optionType };

  return (0, _checkFiltersQuantity2.default)(filters, routeData);
};exports.default =

calculateMobileActiveFiltersQuantity;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/calculateMobileActiveFiltersQuantity.js
// module id = 3086
// module chunks = 0